<template>
  <div class="page-container">
    <!-- About -->
    <div style="display: flex; flex-direction: column; align-items: center">
      <h1 class="display-2">How to play</h1>

      <ol style="text-align: left; font-size: 1.3rem">
        <li>Select Difficulty</li>
        <li>Set Question Count</li>
        <li>Answer Questions</li>
        <li>Check Your Score</li>
      </ol>

      <p style="font-size: 1.2rem">That's it, there's not more to it!</p>
    </div>

    <!-- Intro -->
    <router-link class="router-link" to="/">
      <button type="button" id="btn" class="btn-lg">Back</button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "AboutPage",
  components: {},
};
</script>

<style>
.page-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.display-2 {
  margin-bottom: 1.5rem;
}

#btn {
  width: 200px;
  padding: 10px;
  margin: 10px;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1.2rem;
  cursor: pointer;
}

.router-link {
  color: white;
  text-decoration: none;
}

#btn:hover {
  background-color: #555;
}

@media only screen and (max-width: 600px) {
  .display-1 {
    font-size: calc(5.625rem + 4.5vw);
  }

  #btn {
    font-size: 1.5rem;
  }
}
</style>
